import React, { useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { ParsedCSVResponse, ParsedCSVRow } from 'shared';
import { UploadStep } from './bankimport/UploadStep';
import { ReviewStep } from './bankimport/ReviewStep';
import { CompletionStep } from './bankimport/CompletionStep';

type WizardStep = 'upload' | 'review' | 'complete';

interface BankImportWizardProps {
  visible: boolean;
  onHide: () => void;
}

export const BankImportWizard: React.FC<BankImportWizardProps> = ({ visible, onHide }) => {
  const [step, setStep] = useState<WizardStep>('upload');
  const [parsedRows, setParsedRows] = useState<ParsedCSVRow[]>([]);
  const [results, setResults] = useState({ created: 0, skipped: 0, totalAmount: 0 });

  const handleParsed = (data: ParsedCSVResponse) => {
    setParsedRows(data.rows);
    setStep('review');
  };

  const handleComplete = (res: { created: number; skipped: number; totalAmount: number }) => {
    setResults(res);
    setStep('complete');
  };

  const handleDone = () => {
    setStep('upload');
    setParsedRows([]);
    setResults({ created: 0, skipped: 0, totalAmount: 0 });
    onHide();
  };

  const handleHide = () => {
    handleDone();
  };

  return (
    <Dialog
      data-component="bank-import-wizard"
      header={
        step === 'upload' ? 'Import Bank CSV' :
        step === 'review' ? 'Review Transactions' :
        'Import Complete'
      }
      visible={visible}
      onHide={handleHide}
      style={{ width: 'min(95vw, 1400px)' }}
      maximizable
      modal
      closable
    >
      {step === 'upload' && (
        <UploadStep onParsed={handleParsed} />
      )}
      {step === 'review' && (
        <ReviewStep rows={parsedRows} onComplete={handleComplete} />
      )}
      {step === 'complete' && (
        <CompletionStep
          created={results.created}
          skipped={results.skipped}
          totalAmount={results.totalAmount}
          onDone={handleDone}
        />
      )}
    </Dialog>
  );
};
